import { render, staticRenderFns } from "./display.vue?vue&type=template&id=2c032cdb&scoped=true"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"
import style0 from "./display.vue?vue&type=style&index=0&id=2c032cdb&prod&lang=scss"
import style1 from "./display.vue?vue&type=style&index=1&id=2c032cdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c032cdb",
  null
  
)

export default component.exports